<template>
<div class="yk-single-choice">

    <el-form-item :label="'题目'+(index+1)+'：单选题'" style='margin-bottom: 10px;'>
        <Editor v-model="form.questionTitle" placeholder="请输入题干"/>
    </el-form-item>
    <el-form-item label="选项" class="yk-radioChoice" style='border:0;margin-bottom:0'>
        <div class="yk-op-choice-child" v-for="(item,index) in form.radioData" :key="index+1">
            <el-radio>{{indexArr[index]}}</el-radio>
            <div class="yk-input-show-single">
              <el-input v-model="form.radioData[index]" placeholder="">
                <el-radio-group v-model="form.radio[0]" v-if='form.radio[0]===index' slot='append'>
                  <el-radio-button :label="index">正确答案</el-radio-button>
                </el-radio-group>
                <el-radio-group v-model="form.radio[0]" v-else slot='append'>
                  <el-radio-button :label="index">设为正确答案</el-radio-button>
                </el-radio-group>
              </el-input>
            </div>
            <i class="el-icon-close" @click="closeChoice(index)" v-if="form.radioData.length > 2"></i>
        </div>
    </el-form-item>

    <el-form-item label="" class='yk-add-item'>
        <el-button type="primary" @click="addChoice()" icon='el-icon-circle-plus-outline'>添加选项</el-button>
    </el-form-item>
    <!-- <el-form-item label="正确答案">
        <div class="yk-correct-answer">
        <span>{{form.correctAnswer}}</span>
        </div>
    </el-form-item> -->

    <el-form-item label="解析" style='margin-bottom:0'>
        <Editor v-model="form.analysisContent" placeholder="请输入内容"/>
    </el-form-item>
    <el-form-item label=""  class='yk-single-delete'>
      <el-button type="primary" @click="remove()" style="float:right" icon='el-icon-delete'>删除题目</el-button>
    </el-form-item>
</div>
</template>

<script>
import { SaveQuestion } from "api/v1.desgin.question.ts";
import { Message } from "element-ui";
export default {
  name: "h-h",
  props: {
    iSubmit:{
      type: Boolean,
      default: false
    },
    sortOrder:{
      type:Number,
      default:0
    },
    childQuestion:{
      tyoe:Object,
      default:null
    },
    showChoice:{
      type:Boolean,
      default:false
    },
    index:{
      type:Number,
      default:0
    }
  },
  created() {
    this.form = this.childQuestion;
  },
  data() {
    return {
      cont: [],
      content: "请输入内容",
      check: [],
      indexArr: ["A.","B.","C.","D.","E.","F.","G.","H.","I.","J.","K.","L.","M.","N.","O.","P.","Q.","R.","S.","T.","U.","V.","W.","X.","Y.","Z."],
      correctAnswer:"",
      form: {
        questionTitle: "",
        radio: [-1], //单选题题答案
        radioData: ["", "", "", ""], //单选与多选的框
        correctAnswer: "",
        analysisContent: "",
        sortOrder:0
      }
    };
  },
  watch: {
    "form.radio": function(val) {
      this.form.correctAnswer = this.indexArr[val[0]];
    },
    iSubmit:function(val){
      if(val)
      {
        this.$emit('done', {
          form:this.form
        });
      }
    },
    showChoice:function(val){
      if(val){
        this.form = this.childQuestion;
      }
      else{
        this.form ={
          questionTitle: "",
          radio: [-1], //单选题题答案
          radioData: ["", "", "", ""], //单选与多选的框
          correctAnswer: "",
          analysisContent: "",
          sortOrder:0
        }
      }
    }
  },
  methods: {
    // 添加选项
    addChoice: function() {
      let dataRadioCopy = this.form.radioData;
      let lengthAdd = dataRadioCopy.length;
      if (lengthAdd >= 26) {
        Message.warning("最多只能添加26个选项");
      }
      else{
        this.form.radioData.push("");
      }
    },
    // 删除选项
    closeChoice: function(index) {
      this.form.radioData.splice(index, 1);
    },
    //
    formSubmit: function() {
      let numIndex = this.numType;
      if (numIndex == "") {
        Message.warning("未选择题型无法提交");
      }
      let correctAnswerArray = [],
        selectArray = [];
      this.setCorrectArray(numIndex, correctAnswerArray, selectArray);
      this.$emit("newNodeEvent", {
        questionId: this.quetionId,
        quesType: this.numType,
        diffcult: this.diffTypeValue,
        content: this.stemContent,
        selects: selectArray,
        correctAnswers: correctAnswerArray,
        analysis: this.analysisContent
      });
      this.cleanData();
    },
    remove:function(){
       this.$emit('remove',this.index);
    }
  }
};
</script>

<style lang="scss" scoped>

.yk-multiselect {
  .el-form-item .el-form-item {
    margin-bottom: 20px;
  }
  .el-input {
    width: 85%;
    margin-left: 15px;
  }
  i.el-icon-close {
    font-size: 15px;
    margin-left: 10px;
  }

  .el-col .yk-addChoice {
    margin-left: 70px;
    color: #606266;
  }
}
.yk-single-con {
  .yk-radioChoice {
    .yk-op-choice-child {
      margin-top: 4px;
      label,
      .yk-input-show-single,
      i {
        display: inline-block;
      }
      .yk-input-show-single {
        width: 560px;
      }
    }
  }
}
</style>

